import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
export default function CampaignEligibleLeadSelect({ campaignId, recipients, value, onChange }) {
 const [search, setSearch] = useState('');
 const [options, setOptions] = useState([]);
 const [selected, setSelected] = useState(null);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState('');
 const option = lead => ({ value: String(lead.id), label: `${lead.name} · ${lead.phone}` });
 useEffect(() => {
  let live = true; setLoading(true); setError(''); setOptions([]);
  const timer = setTimeout(() => {
   axios.get(`/api/crm/campaigns/${campaignId}/eligible-leads`, { params: { busca: search } }).then(r => { if (live) setOptions((r.data.leads || []).map(option)); }).catch(() => { if (live) setError('Não foi possível buscar os leads. Digite novamente para tentar.'); }).finally(() => { if (live) setLoading(false); });
  }, 300);
  return () => { live = false; clearTimeout(timer); };
 }, [campaignId, search]);
 const initial = recipients.filter(r => r.eligible).map(option);
 const available = !search && loading ? initial : options;
 return <><Select inputId="campaign-test-lead" isSearchable isClearable isLoading={loading} options={available} filterOption={null}
  value={!value ? null : [selected, ...options, ...initial].find(o => o && o.value === String(value)) || null}
  onInputChange={(text, meta) => { if (meta.action === 'input-change') setSearch(text); }}
  onChange={item => { setSelected(item); onChange(item?.value || ''); }}
  placeholder="Digite nome ou telefone" loadingMessage={() => 'Buscando leads…'} noOptionsMessage={() => error || 'Nenhum lead elegível encontrado'} menuPlacement="auto" />
  <small className="text-muted">Busca em toda a audiência. Até 30 resultados por busca.</small>{error && <div role="alert" className="text-danger small">{error}</div>}</>;
}
